/**
 * Classify a Payment Details API payload (no intimation_status handling).
 * @param {object|null|undefined} data
 * @returns {{ outcome: string, paymentStatus: string|null }}
 */
export function classifyPaymentDetailsStatus(data) {
  const paymentStatus = data?.payment_status?.toLowerCase() || null;

  if (paymentStatus === 'failed') {
    return { outcome: 'failure', paymentStatus };
  }

  if (paymentStatus === 'success') {
    return { outcome: 'success', paymentStatus };
  }

  if (paymentStatus === 'verification_failed') {
    return { outcome: 'verification_failed', paymentStatus };
  }

  return { outcome: 'pending', paymentStatus };
}
